// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1792641796482
      var cssReload = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  